import * as filters from '@/utils/filters'
export default {
  props: {
    fields: {
      type: Array,
      default: () => ([])
    }
  },
  computed: {
    preparedList () {
      return this.fields.map((item) => {
        return {
          fieldName: item.fieldName,
          title: item.title,
          classes: item.classes || '',
          filter: item.filter || null
        }
      })
    },
    showedList () {
      return []
    }
  },
  methods: {
    filter (data, { filter, fieldName }) {
      let value = data[fieldName]
      const filterFun = filters[filter] || ((val) => val)
      return filterFun(value)
    }
  }
}
